import { useFormikContext } from "formik";
import CtaButtonFieldArray from "./CtaButtonFieldArray";
import QuickReplyButtonFieldArray from "./QuickReplyButtonFieldArray";
import { useEffect } from "react";


const RenderDynamicButton: React.FC<IRenderDynamicButtonTypes> = ({
  buttonType = "none",
  disabled = false,
}) => {

  const {  setFieldError, setFieldTouched } = useFormikContext<any>();

  useEffect(() => {
      setFieldError("cta_buttons", "");
      setFieldError("quick_buttons", "");
      setFieldTouched("quick_buttons", false);
      setFieldTouched("cta_buttons", false);
  }, [buttonType]); // eslint-disable-line react-hooks/exhaustive-deps

  if (buttonType === "call_to_action") {
    return <CtaButtonFieldArray
      name="cta_buttons"
      disabled={disabled}
      variablesKey="buttons_example"
      divStyle={{ marginTop: "-0.5rem" }}
    />
  } else if (buttonType === "quick_reply") {
    return <QuickReplyButtonFieldArray
      disabled={disabled}
      name="quick_buttons"
      divStyle={{ marginTop: "-0.5rem" }}
    />
  } else {
    return null
  }
};

export default RenderDynamicButton;
